import { useModuleContext } from 'root/src/client/util/withModuleContext'
import moduleDescriptions from 'root/src/shared/descriptions/modules'

export const useListRouteId = () => {
	const { moduleId } = useModuleContext()
	return moduleDescriptions?.[moduleId]?.listRouteId
}
